module.exports = __webpack_public_path__ + "img/sud.ee6d3bdb.png";